<template>
  <div>
    <el-dialog
      top="10vh"
      width="405px"
      center
      title="操作员管理"
      :visible="operatorDialogVisible"
      @close="HandleCancel"
    >
      <el-form :ref="form" label-width="110px">
        <el-form-item label="指定银行卡">
          {{ data.bankCardNumber }}
        </el-form-item>
        <el-form-item v-if="data.operatorUsername" label="已指派操作员">
          {{ data.operatorUsername }}
          <el-button
            style="margin-left: 10px"
            size="mini"
            type="danger"
            @click="HandleDeleteOperator"
            >取消指派</el-button
          >
        </el-form-item>
        <el-form-item label="指派操作员">
          <el-select
            filterable
            size="small"
            placeholder="请选择操作员"
            v-model="operatorUserId"
          >
            <el-option
              v-for="item in operatorList"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel"> 取消 </el-button>
        <el-button :loading="loading" round type="success" @click="HandleVaild">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { getUserList } from "@/api/user";
import { assignOperator, unassignOperator } from "@/api/bank";

export default {
  mixins: [mainCommon],
  props: ["data"],
  data() {
    return {
      operatorUserId: null,
      operatorDialogVisible: false,
      operatorList: [],
      loading: false,
      form: "form",
    };
  },
  watch: {
    data(row) {
      if (row) {
        this.operatorDialogVisible = true;
        this.HandleOperatorList();
      }
    },
  },
  methods: {
    HandleCancel() {
      this.operatorUserId = null;
      this.operatorDialogVisible = false;
    },
    HandleVaild() {
      if (!this.operatorUserId) {
        return this.$notify.error("请指派一个操作员");
      }
      this.HandleSubmit();
    },
    HandleSubmit() {
      this.loading = true;
      assignOperator({
        accId: this.data.accId,
        operatorUserId: this.operatorUserId,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.HandleCancel();
          this.$emit("HandleGetList");
          // 再请求一次红点泡泡
          this.$store.dispatch("GetUnallocatedAll");
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    HandleDeleteOperator() {
      this.$confirm("确定取消指派操作员？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "error",
      })
        .then(() => {
          unassignOperator({
            accId: this.data.accId,
          }).then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
            // 再请求一次红点泡泡
            this.$store.dispatch("GetUnallocatedAll");
          });
        })
        .catch(() => {});
    },
    HandleOperatorList() {
      getUserList({
        pageSize: varCommon.pagination.pageSizeNoLimit,
        pageNum: 1,
        userType: "operator",
      })
        .then((res) => {
          this.operatorList = res.data.list.map((res) => {
            return { label: res.username, value: res.id };
          });
        })
        .catch(() => {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bank/OperatorDialog.vue